<template>
    <div class="home">
        <v-row>
            <v-col cols="12" md="6" sm="6" style="padding-right: 20px;padding-left: 20px">
                <ve-histogram :data="chartDataHistogram"></ve-histogram>
            </v-col>
            <v-col cols="12" md="6" sm="6" style="padding-right: 20px;padding-left: 20px">
                <ve-line :data="chartData" :settings="chartSettings"></ve-line>
            </v-col>
            <v-col cols="12" md="6" sm="6" style="padding-right: 20px;padding-left: 20px">
                <ve-bar :data="chartDataBar"></ve-bar>
            </v-col>
            <v-col cols="12" md="6" sm="6" style="padding-right: 20px;padding-left: 20px">
                <ve-pie :data="chartDataPie"></ve-pie>
            </v-col>
        </v-row>
    </div>
</template>

<script>
    // @ is an alias to /src";
    export default {
        name: "Dashboard",
        components: {},
        data() {
            this.chartSettings = {
                metrics: ['cost', 'profit'],
                dimension: ['date']
            };
            return {
                chartSettings: {},
                chartData: {
                    columns: ['date', 'PV', 'Order'],
                    rows: [
                        {'date': '2018-05-22', 'PV': 32371, 'Order': 19810},
                        {'date': '2018-05-23', 'PV': 12328, 'Order': 4398},
                        {'date': '2018-05-24', 'PV': 92381, 'Order': 52910}
                    ]
                },
                chartDataHistogram: {
                    columns: ['date', 'cost', 'profit', 'growthRate', 'people'],
                    rows: [
                        {'cost': 1523, 'date': '01/01', 'profit': 1523, 'growthRate': 0.12, 'people': 100},
                        {'cost': 1223, 'date': '01/02', 'profit': 1523, 'growthRate': 0.345, 'people': 100},
                        {'cost': 2123, 'date': '01/03', 'profit': 1523, 'growthRate': 0.7, 'people': 100},
                        {'cost': 4123, 'date': '01/04', 'profit': 1523, 'growthRate': 0.31, 'people': 100}
                    ]
                },
                chartDataBar: {
                    columns: ['date', 'cost', 'profit'],
                    rows: [
                        {'date': '01/01', 'cost': 123, 'profit': 3},
                        {'date': '01/02', 'cost': 1223, 'profit': 6},
                        {'date': '01/03', 'cost': 2123, 'profit': 90},
                        {'date': '01/04', 'cost': 4123, 'profit': 12},
                        {'date': '01/05', 'cost': 3123, 'profit': 15},
                        {'date': '01/06', 'cost': 7123, 'profit': 20}
                    ]
                },
                chartDataPie: {
                    columns: ['date', 'cost', 'profit'],
                    rows: [
                        {'date': '01/01', 'cost': 123, 'profit': 3},
                        {'date': '01/02', 'cost': 1223, 'profit': 6},
                        {'date': '01/03', 'cost': 2123, 'profit': 90},
                        {'date': '01/04', 'cost': 4123, 'profit': 12},
                        {'date': '01/05', 'cost': 3123, 'profit': 15},
                        {'date': '01/06', 'cost': 7123, 'profit': 20}
                    ]
                }
            }
        }
    };
</script>
